import { useRef, useState, useEffect } from 'react';
import TextBoxControl from "../../../Controls/TextBoxControl"
import GridControl from "../../../Controls/GridControl"
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import {
	GetLocal,
	FetchService,
	SetLocal
} from "../../../Base/BaseControl";

export default function Index(props) {

	const [getServiceResult, setServiceResult] = useState(false);
	const [getPdf, setPdf] = useState('');
	const [showModal, setShowModal] = useState(false);
	const [getIPGType, setIPGType] = useState(null);

	useEffect(() => {
		var inputValue = {
			session: GetLocal('OwnersSession')
		};
		FetchService("Owner/Residential/Request/ShowUrbanBillsList", inputValue, ShowUrbanBillsListSuccess);
	}, []);

	const ShowUrbanBillsListSuccess = (ServiceResult) => {
		setServiceResult(ServiceResult.UrbanBillList);
		setIPGType(ServiceResult.IPGType)
		SetLocal("IPGType", ServiceResult.IPGType)
	}

	const PaymentAction = (row) => {
		var inputValue = {
			session: GetLocal('OwnersSession'),
			serialNumber: row.SerialNumber && String(row.SerialNumber)
		};
		if (getIPGType === 1) {
			FetchService("Owner/Residential/Request/IPGUrbanizationPaymentRequestByNovin", inputValue, IPGUrbanizationPaymentRequestSuccess);
		} else if (getIPGType === 0) {
			FetchService("Owner/Residential/Request/IPGUrbanizationPaymentRequest", inputValue, IPGUrbanizationPaymentRequestSuccess);
		}

	}


	const IPGUrbanizationPaymentRequestSuccess = (ServiceResult) => {
		window.location = ServiceResult.RedirectURL + '&returnURL=' + window.location.protocol + '//' + window.location.host + '/ReturnFromIPGUrbanizatio/'
	}

	const ViewFish = (row) => {
		var inputValue = {
			session: GetLocal('OwnersSession'),
			serialNumber: row.SerialNumber && String(row.SerialNumber)
		};
		FetchService("Owner/Residential/Report/ShowUrbanizationChargesReport", inputValue, ShowUrbanizationChargesReportSuccess);
	}

	const ShowUrbanizationChargesReportSuccess = (ServiceResult) => {
		setPdf("data:application/pdf;base64," + ServiceResult);
		setShowModal(true)
	}

	const DataGrid = () => {
		return (
			<GridControl
				data={getServiceResult}
				customHeaders={{ "SerialNumber": "سریال", "BillNumber": "شماره فیش", "IssueDate": "تاریخ صدور", "Amount": "مبغ اعلام شده", "Status": "وضعیت", "ViewFish": "مشاهده فیش", "PaymentAction": "پرداخت" }}
				PaymentAction={PaymentAction}
				ViewFish={ViewFish}
			/>
		)
	}

	return (
		<div>
			<DataGrid />

			<Modal dialogClassName="modalUi" show={showModal} onHide={() => setShowModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title></Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<iframe src={getPdf} width="100%" style={{ height: "500px" }}></iframe>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="danger" onClick={() => setShowModal(false)}>
						بستن
					</Button>
				</Modal.Footer>
			</Modal>
		</div>
	);
}
